import { DialogContent, DialogTitle, Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"

export function ProjectDialog() {
    return (
        <DataInputDialog okCaption={"Add"}>
            <DialogTitle data-cy="add-work-package-title">Add Work Package</DialogTitle>
            <DialogContent>
                <Stack sx={{ mt: 2 }} spacing={1}>
                    <BoundTextField
                        field="name"
                        label="Name"
                        yup="string.required.trim"
                        autoFocus
                        data-cy="project-name-input"
                    />
                    <BoundTextField
                        field="internalDescription"
                        label="Internal Description"
                        multiline
                        minRows={4}
                        maxRows={10}
                        overflow="scroll"
                        data-cy="project-description-input"
                    />
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
